import Immutable from 'immutable'
import * as types from '../../types'

const INITIAL_STATE = Immutable.fromJS({

})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        default:
            return state
    }
}